module.exports = __webpack_public_path__ + "img/ico_input_search_focus.fa96d6be.svg";